import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../helpers/axiosConfig';
import { AuthContext } from '../helpers/AuthContext';
import { useNavigate } from 'react-router-dom';
function Post() {
  const { id } = useParams();
  const [post, setPost] = useState({});
  const [commente, setCommentes] = useState([]);
  const [newCommente, setNewCommente] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`posts/byId/${id}`).then((response) => {
      setPost(response.data);
    });
    axios.get(`comments/${id}`).then((response) => {
      setCommentes(response.data);
    });
  }, []);

  const { isAuthenticated } = useContext(AuthContext);

  const supprimerComment = (id) => {
    axios
      .delete(`comments/${id}`, {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then(() => {
        setCommentes(commente.filter((element) => element.id !== id));
        alert('Suppression avec succes');
      });
  };

  const addComment = () => {
    if (!isAuthenticated.status) navigate('/login');

    axios.post(`comments/`, { commentaire: newCommente, PostId: id }, { headers: { accessToken: localStorage.getItem('accessToken') } }).then((response) => {
      if (response.data.error) {
        setError(response.data.error);
      } else {
        const nouveauCommente = {
          commentaire: newCommente,
          username: response.data.username,
          createdAt: new Date().toLocaleDateString(),
        };
        setCommentes([...commente, nouveauCommente]);
        setNewCommente('');
      }
    });
  };
  const handleChange = (e) => setNewCommente(e.target.value);

  const supprimerPost = (id) => {
    axios
      .delete(`posts/${id}`, {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((res) => {
        navigate('/home');
      });
  };

  const editPost = (postId) => {
    console.log(postId);
  };
  return (
    <div className="container">
      <div>Post N° {id} </div>
      <div className="card">
        <div className="card-header">
          <i
            className="text-success fa fa-edit "
            onClick={() => {
              editPost(post.id);
            }}
          ></i>
          {post.title}
        </div>
        <div className="card-body"> {post.postText} </div>
        <div className=" card-footer d-flex justify-content-between">
          <div>{post.username}</div>
          <div>{isAuthenticated.username === post.username && <i className=" text-danger fa fa-trash fa-3" onClick={() => supprimerPost(post.id)}></i>}</div>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col">
          <div>
            <label htmlFor="commentaire">Commentaire </label>
            <input type="text" id="commentaire" name="commentaire" className="form-control" autoComplete="off" onChange={handleChange} value={newCommente} />
          </div>
        </div>
        <div>
          <div className="col ">
            <button onClick={addComment} type="submit" className="btn btn-primary">
              Envoyé
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div>Liste des commentaires ({commente.length}) </div>
          {error ? (
            <div id="erreur" className="col-md-12 bg-danger rounded-3 p-3 ">
              <h3>{error}</h3>
            </div>
          ) : (
            ''
          )}
          {commente.map((element, k) => {
            // let date = new Date(element.createdAt).toLocaleDateString()
            // let time = new Date(element.createdAt).toLocaleTimeString()
            return (
              <div className="col m-2" key={k}>
                <label htmlFor="" className="text-info">
                  par : <span>{element.username}</span>
                </label>
                <div className="col d-flex justify-content-between">
                  <div className="card-title"> {element.commentaire} </div>

                  {isAuthenticated.username === element.username ? (
                    <div
                      href=""
                      onClick={() => {
                        supprimerComment(element.id);
                      }}
                    >
                      <i className="fa fa-trash"></i>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Post;
